var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dash',{attrs:{"icon":"fa fa-book","titulo":"PROJETOS SGTEC"},nativeOn:{"click":function($event){return _vm.$router.push({ name: 'Sgtec_Fornecedor_Projetos' })}}})
}
var staticRenderFns = []

export { render, staticRenderFns }